// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ma-z","fullWidth":"Na-z","heading":"Oa-z","fullBleed":"Pa-z","hidden":"Qa-z"};